import { useState } from 'react';

type SegmentDurum = 'Sıcak' | 'Ilık' | 'Soğuk' | 'VIP' | 'Beklemede';
type IsSeviyesi = 'Başlangıç' | 'Orta' | 'Üst Düzey' | 'Kurumsal';

interface FormData {
  ad_soyad: string;
  telefon: string;
  segment_durum: SegmentDurum;
  is_seviyesi: IsSeviyesi;
}

const initialForm: FormData = {
  ad_soyad: '',
  telefon: '',
  segment_durum: 'Ilık',
  is_seviyesi: 'Orta',
};

export default function ManuelEkle() {
  const [form, setForm] = useState<FormData>(initialForm);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState<Partial<FormData>>({});

  function validate() {
    const e: Partial<FormData> = {};
    if (!form.ad_soyad.trim()) e.ad_soyad = 'Ad soyad zorunludur';
    if (!form.telefon.trim()) e.telefon = 'Telefon zorunludur';
    else if (!/^\+?\d[\d\s]{9,14}$/.test(form.telefon.trim())) e.telefon = 'Geçerli bir telefon girin';
    return e;
  }

  async function handleSubmit(e: React.FormEvent) {
  e.preventDefault();

  const errs = validate();
  if (Object.keys(errs).length > 0) {
    setErrors(errs);
    return;
  }

  setErrors({});

  try {
    const res = await fetch("/api/manuel_basvuru_ekle.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (data.status === "success") {
      setSubmitted(true);
    } else {
      alert("Hata: " + data.message);
    }

  } catch (err) {
    console.error(err);
    alert("Sunucu hatası");
  }
}

  function handleReset() {
    setForm(initialForm);
    setErrors({});
    setSubmitted(false);
  }

  if (submitted) {
    return (
      <div className="space-y-5">
        <div>
          <h1 className="text-xl font-bold text-white">Manuel Başvuru Ekle</h1>
        </div>
        <div className="max-w-lg mx-auto rounded-xl bg-emerald-500/10 border border-emerald-500/30 p-10 flex flex-col items-center gap-4 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-emerald-500/20">
            <i className="ri-check-line text-3xl text-emerald-400" />
          </div>
          <div>
            <p className="text-white font-bold text-lg">Başvuru Başarıyla Eklendi</p>
            <p className="text-white/40 text-sm mt-1">
              <span className="text-white/70 font-semibold">{form.ad_soyad}</span> sisteme kaydedildi.
            </p>
          </div>
          <button
            onClick={handleReset}
            className="px-6 py-2.5 rounded-lg bg-amber-500/20 hover:bg-amber-500/30 text-amber-400 text-sm font-semibold transition-all cursor-pointer"
          >
            Yeni Başvuru Ekle
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-white">Manuel Başvuru Ekle</h1>
        <p className="text-white/30 text-sm mt-0.5">Yönetici tarafından manuel olarak sisteme ekle</p>
      </div>

      <div className="max-w-2xl">
        <form
          onSubmit={handleSubmit}
          className="rounded-xl bg-white/[0.03] border border-white/[0.07] p-6 space-y-5"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* Ad Soyad */}
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs font-semibold uppercase tracking-wider">
                Ad Soyad <span className="text-amber-400">*</span>
              </label>
              <input
                value={form.ad_soyad}
                onChange={(e) => setForm({ ...form, ad_soyad: e.target.value })}
                placeholder="Örn: Ahmet Kaya"
                className="bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-2.5 text-white text-sm placeholder:text-white/20 focus:outline-none focus:border-amber-500/50"
              />
              {errors.ad_soyad && <p className="text-rose-400 text-xs">{errors.ad_soyad}</p>}
            </div>

            {/* Telefon */}
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs font-semibold uppercase tracking-wider">
                Telefon <span className="text-amber-400">*</span>
              </label>
              <input
                value={form.telefon}
                onChange={(e) => setForm({ ...form, telefon: e.target.value })}
                placeholder="+90 5XX XXX XX XX"
                className="bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-2.5 text-white text-sm font-mono placeholder:text-white/20 focus:outline-none focus:border-amber-500/50"
              />
              {errors.telefon && <p className="text-rose-400 text-xs">{errors.telefon}</p>}
            </div>

            {/* Segment */}
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs font-semibold uppercase tracking-wider">Segment Durumu</label>
              <select
                value={form.segment_durum}
                onChange={(e) => setForm({ ...form, segment_durum: e.target.value as SegmentDurum })}
                className="bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-2.5 text-white text-sm focus:outline-none focus:border-amber-500/50 cursor-pointer"
              >
                {(['Sıcak', 'Ilık', 'Soğuk', 'VIP', 'Beklemede'] as SegmentDurum[]).map((s) => (
                  <option key={s} value={s} className="bg-[#0f1420]">{s}</option>
                ))}
              </select>
            </div>

            {/* İş Seviyesi */}
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs font-semibold uppercase tracking-wider">İş Seviyesi</label>
              <select
                value={form.is_seviyesi}
                onChange={(e) => setForm({ ...form, is_seviyesi: e.target.value as IsSeviyesi })}
                className="bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-2.5 text-white text-sm focus:outline-none focus:border-amber-500/50 cursor-pointer"
              >
                {(['Başlangıç', 'Orta', 'Üst Düzey', 'Kurumsal'] as IsSeviyesi[]).map((s) => (
                  <option key={s} value={s} className="bg-[#0f1420]">{s}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Info note */}
          <div className="flex items-start gap-3 rounded-lg bg-amber-500/10 border border-amber-500/20 px-4 py-3">
            <i className="ri-information-line text-amber-400 mt-0.5" />
            <p className="text-white/50 text-xs leading-relaxed">
              Manuel eklenen başvurular <span className="text-amber-400 font-semibold">Kaynak: Manuel</span> olarak işaretlenir.
              IP adresi ve kullanıcı ajanı alanları otomatik atlanır.
            </p>
          </div>

          <div className="flex items-center gap-3 pt-1">
            <button
              type="submit"
              className="px-6 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-black text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-user-add-line mr-2" />
              Başvuruyu Ekle
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="px-4 py-2.5 rounded-lg bg-white/[0.05] hover:bg-white/[0.08] text-white/40 hover:text-white/70 text-sm font-medium transition-all cursor-pointer"
            >
              Sıfırla
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
